<template>
<div>
    <!-- Page -->
    <sav-template :title="$t('mes_produits.produit.mes_produits')" :back-button="false">
        <sav-spinner more-class="mb-3" v-show="loading" />
        <div v-if="products.length <= 0 && !loading" class="p-6 mb-3 bg-white shadow my-rounded">
            {{$t('mes_produits.produit.aucun_produit')}}
        </div>
        <template v-if="products.length > 0">
            <div class="product-cards">
                <div v-for="(item, index) in products" :key="item.id" class="mb-3">
                    <sav-fold-card :id="item.id_case + '-' + item.id_appareil" :title="'<b>' + (item['Libelle'] ? item['Libelle'] : '[' + item['Modele'] + ']') + '</b>'" v-model="item.isOpen" :test-id="'product-' + index">
                        <template v-slot:close>
                            <div class="flex items-center justify-between">
                                <div>
                                    <div class="flex items-center">
                                        <img class="h-10 mr-3" :src="item.default_case.groupe.img" alt="">
                                        <div>
                                            <h5 class="capitalize">
                                                <b>{{item['Marque']}}</b> - {{(item['Libelle'] ? item['Libelle'] : '[' + item['Modele'] + ']')}}
                                            </h5>
                                            <small class="font-light" v-if="item && item.id_case && item.id_case.length > 0">{{item.id_case[0].date_maj | moment}}</small>
                                        </div>
                                    </div>
                                    <template v-if="item && item.id_case && item.id_case.length > 0">
                                        <div class="mt-2 bg-gray-100 p-4 rounded-xl">
                                            <badge-state :state="item.etat" :label="item.id_case[0].statut" :date="item.id_case[0].date_maj" />
                                        </div>
                                    </template>
                                </div>
                                <i class="fas fa-angle-right"></i>
                            </div>
                        </template>
                        <template v-slot:open>
                            <!-- {{$t('mes_produits.produit.produit')}} -->
                            <h6 class="mt-3 font-bold">{{$t('mes_produits.produit.produit')}}</h6>
                            <span class="text-gray-600 break-words"> {{ item['Modele'] + ' ' + item['Marque'] }} </span>
                            <!-- Ean -->
                            <hr class="mt-3">
                            <h6 class="mt-3 font-bold">{{$t('mes_produits.produit.ean')}}</h6>
                            <span class="text-gray-600 break-words"> {{ item.Ean }} </span>
                            <!-- Numéro série -->
                            <template v-if="item.num_serie && item.num_serie != 'null'">
                                <hr class="mt-3">
                                <h6 class="mt-3 font-bold">{{$t('mes_produits.produit.numero_de_serie')}}</h6>
                                <span class="text-gray-600 break-words"> {{ item.num_serie }} </span>
                            </template>
                            <!-- Vendeur -->
                            <hr class="mt-3">
                            <template v-if="item.default_case && item.default_case.magasin">
                                <h6 class="mt-3 font-bold">{{$t('mes_produits.produit.vendeur')}}</h6>
                                <span class="text-gray-600 break-words"> {{ item.default_case.magasin.name + ' - ' + item.default_case.magasin.ville + ', ' + item.default_case.magasin.cp }} </span>
                            </template>
                            <!-- Date Achat -->
                            <template v-if="isValidDate(item.date_ha)">
                                <hr class="mt-3">
                                <h6 class="mt-3 font-bold">{{$t('mes_produits.produit.date_achat')}}</h6>
                                <span class="text-gray-600 break-words"> {{ item.date_ha | moment }} </span>
                            </template>
                            <!-- Dossiers -->
                            <template v-if="item.cases.length > 0">
                                <hr class="mt-3">
                                <h6 class="mt-3 font-bold" v-if="item.cases.length <= 1">{{$t('mes_produits.produit.mon_dossier')}}</h6>
                                <h6 class="mt-3 font-bold" v-else>{{$t('mes_produits.produit.mes_dossiers')}}</h6>
                                <div v-for="(caseData, caseIndex) in item.cases" :key="'case-' + caseIndex">
                                    <folder-card class="mt-3 mb-5" :id="caseData.id" :state="item.etat" :default-data="caseData" :status="caseData.statut" :date-last-maj="caseData.date_maj" />
                                </div>
                            </template>
                            <!-- Documents -->
                            <template v-if="item.doc && item.doc.length > 0">
                                <h6 class="mt-3 font-bold">{{$t('mes_produits.produit.documents')}}</h6>
                                <div v-for="(item, docIndex) in item.doc" :key="'doc-' + docIndex">
                                    <div class="flex items-center justify-between"> {{item.typedoc}}
                                        <a :href="item.url_notice" target="_blank" class="no-underline text-gray-900 bg-white border border-gray-300 focus:outline-none focus:ring-4 focus:ring-gray-200 font-medium rounded-lg px-2 py-1.5 font-light text-xs">
                                            <i class="fa fa-eye mr-0.5"></i> {{$t('mes_produits.produit.consulter')}}
                                        </a>
                                    </div>
                                </div>
                            </template>
                            <!-- Actions -->
                            <template v-if="(item.id_case.length <= 0 || item.etat == 2)">
                                <hr class="mt-3">
                                <h6 class="mt-3 font-bold">{{$t('mes_produits.produit.actions')}}</h6>
                                <!-- Create new case -->
                                <button v-if="item.id_case.length <= 0 || item.etat == 2" @click="createSavCase(item)" class="px-3 py-2 mt-3 text-sm font-light text-white duration-100 bg-green-500 hover:bg-green-600 rounded-xl">
                                    <small>
                                        <i class="mr-1 fas fa-redo"></i>{{$t('mes_produits.produit.nouvelle_demande_sur_ce_produit')}}
                                    </small>
                                </button>
                            </template>
                        </template>
                    </sav-fold-card>
                </div>
            </div>
        </template>
    </sav-template>
</div>
</template>

<script>
import apiService from '@/services/api.service'
import eventHub from '@/eventHub'
import moment from 'moment'

import FolderCard from './FolderCard.vue'
import BadgeState from './BadgeState.vue'
import apiUploadService from '@/services/apiUpload.service'


export default {
    components: { FolderCard, BadgeState },

    data() {
        return {
            client_id: null,
            loading: false,
            products: [],
            savCase: null,
            modalLoading: false,
            deleteModalData:  null,
        }
    },

    methods: {
        async getProducts() {
            this.loading = true
            let response = await apiService.post('getappconso', {
                id_conso: this.client_id
            })
            this.products = response.data.posts.post
            this.loading = false
        },

        displaySavCase(item) {
            this.getDetailCase(item.id_case)
            this.$modal.show('modal-display-sav-case')
        },

        async getDetailCase(id) {
            this.modalLoading = true
            await apiService.post('getdetailcase', {
                id_case: id
            }).then((response) => {
                this.savCase = response.data.posts.post
                this.modalLoading = false
            })
        },

        createSavCase(item) {
            let data = item.default_case
            let setForms = [
                {
                    storageName: 'brand', apiKeyname: 'marque',
                    renames: [{api: 'marque', storage: 'label'}],
                    default: null,
                },
                {
                    storageName: 'category', apiKeyname: 'groupe',
                    renames: [{api: 'group_name', storage: 'label'}],
                    default: null
                },
                {
                    storageName: 'device', apiKeyname: 'modele',
                    renames: [],
                    default: []
                },
                {
                    storageName: 'sign', apiKeyname: 'enseigne',
                    renames: [{api: 'name', storage: 'label'}],
                    default: null
                },
                {
                    storageName: 'shop', apiKeyname: 'magasin',
                    renames: [],
                    default: []
                }
            ]

            // Clear form
            localStorage.setItem('form-data', JSON.stringify({temp: {}}))

            // Init form
            this.$nextTick(async () => {
                setForms.forEach((form) => {
                    // Rename keys
                    form.renames.forEach((rename) => {
                        data[form.apiKeyname][rename.storage] = data[form.apiKeyname][rename.api]
                        delete data[form.apiKeyname][rename.api]
                    })
    
                    // Transform end value
                    let endObject = data[form.apiKeyname]
                    if (form.default) {
                        endObject = [{value: data[form.apiKeyname]}]
                    }
    
                    // Set in storage
                    this.$formTool.addFormData(form.storageName, endObject)
                })
    
                // Set specific data
                // 1. shop
                let shop = this.$formTool.getFormData('shop')
                shop[0].value.img = this.$formTool.getFormData('sign').img
                shop[0].value.townAndZipCode = this.$addressTool.capitalizeTown(shop[0].value.ville) + shop[0].value.cp
                let response = await apiService.post('getshop', {id_enseigne: this.$formTool.getFormData('sign').id})
                if (response.data.posts.post.length == 0 && response.data.posts.id_mag) {
                    shop = [{type: 'auto', value: {id: response.data.posts.id_mag}}]
                }
                this.$formTool.addFormData('shop', shop)

                // 2. device
                let device = this.$formTool.getFormData('device')
                device.modelDescription = device.description
                device.moreData = device['Modele']
                this.$formTool.addFormData('device', device)

                // Redirect
                this.$router.push({name: 'form.home'})
            })
        },

        closeAllCard(cardIdNotClose) {
            this.products.forEach((item) => {
                if (item.id_case + '-' + item.id_appareil != cardIdNotClose) {
                    item.isOpen = false
                }
            })
        },

        isValidDate(date) {
            var date = moment(date);
            return date.isValid()
        }
    },

    filters: {
        moment(date) {
            return moment(date).format('DD/MM/YYYY');
        },

        momentWithHour(date) {
            return moment(date).format('DD/MM/YYYY à hh:mm');
        }
    },

    mounted() {
        eventHub.$on('card-open-close', (cardInfo) => {
            if (cardInfo.value === true && cardInfo.itemId) {
                this.closeAllCard(cardInfo.itemId)
            }
        })

        eventHub.$on('refresh-product-list', (cardInfo) => {
            this.getProducts()
        })

        this.client_id = this.$crypto.decrypt(localStorage.getItem('client_id'))
        this.getProducts()
    },
}
</script>



// WEBPACK FOOTER //
// src/companies/default/views/user/product/List2.vue